<template>
  <div>
    <v-row class="ma-0 mt-35">
      <v-col class="pa-0">
        <v-data-table
          :headers="$getHeaderType1(headerTxt, headers)"
          :items="documents"
          hide-default-footer
          :items-per-page="9999"
          class="new__type__table"
          :mobile-breakpoint="MobileBreakPoint"
        >
          <template v-slot:item="{item, index}">
            <tr>
              <td>{{ index + 1 }}</td>
              <td>{{ item.type }}</td>
              <!-- Follow-up Actions : S -->
              <td v-if="item.type === 'Document'">
                {{ $vuetify.rtl ? item.service_name_ar : item.service_name_en }}
                <v-chip
                  color="#b22325"
                  dark
                  class="ma-2 inner_chip"
                  v-if="item.drafting"
                >
                {{ item.drafting }}
                </v-chip>
              </td>
              <td v-if="item.type === 'Payment'">
                {{ $vuetify.rtl ? item.fee_config_name_ar : item.fee_config_name_en }}
              </td>
              <td v-if="item.type === 'Annual Fee'">
                {{ $vuetify.rtl ? item.fee_name_ar : item.fee_name_en }}
              </td>
              <!-- Follow-up Actions : E -->
              <td>{{ item.due_date }}</td>
              <td v-if="item.type === 'Document'">
                <v-chip
                  :color="getColor(item.status_type_code)"
                  dark
                  class="mw-170 ma-2 inner_chip"
                  @click="fnSubmitConfirm(item)"
                >
                  {{ $vuetify.rtl ? item.service_name_ar : item.service_name_en}}
                </v-chip>
              </td>
              <td v-if="item.type === 'Payment'">
                <v-chip dark color="#98bbbf" @click="$emit('payment', item)">{{$t('common.button.pay')}}</v-chip>
              </td>
              <td v-if="item.type === 'Annual Fee'">
                <v-chip dark color="#98bbbf" @click="$emit('annualfee', item)">{{$t('common.button.pay')}}</v-chip>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <confirm-dialog :id="id" @confirm="fnSubmit" />
  </div>
</template>
<script>
import requestApi from '@/utils/requestApi'
import utils from '@/utils/utils'
import eventBus from '@/utils/eventBus'
import ConfirmDialog from '@/components/layout/ConfirmDialog'

export default {
  name: 'UpcomingDocumentAll',
  props: {
    seq:  String
  },
  components:{
    ConfirmDialog
  },
  data () {
    return {
      id: 'UpcomingDocumentAll',
      MobileBreakPoint:0,
      headerTxt : {
        prefix : 'myapplication.myapplication_details.fields.',
        txt : [ '#', 'type','followup_actions','due_date','' ]
      },
      headers : [
        { text: '#', align: 'center', width:'65', sortable: false },
        { text: 'Type', align: 'center', width: '120', sortable: false },
        { text: 'Follow-up Actions', align: 'center', sortable: false },
        { text: 'Due Date', align: 'center', width: '120', sortable: false },
        { text: '',  align: 'center', sortable: false },
      ],
      documents : [],
      listNo : 1
    }
  },
  mounted(){
    this.listNo = 1
    this.documents = []
    this.fnGetDocuments()
    this.fnGetPayments()
    this.fnGetAnnualfees()
  },
  methods : {

    fnGetDocuments(){
      if (this.seq) {
        requestApi({
          url: '/applications/' + this.seq + '/upcoming/documents',
          method: 'GET',
          callback: (res) => {
            if (res.res_code === '200') {
              for (let i = 0; i < res.data.list.length; i++) {
                res.data.list[i].no = this.listNo++
                res.data.list[i].type = "Document"
                this.documents.push(res.data.list[i])
              }
            }else{
              if (res.res_code === '401012') {
                utils.setTokenRefresh().then(() => {
                  this.fnGetDocuments()
                })
              } else {
                eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
              }
            }
          }
        })
      }
    },

    fnGetPayments(){
      if (this.seq) {
        requestApi({
          url: '/applications/' + this.seq + '/upcoming/payments',
          method: 'GET',
          callback: (res) => {
            if (res.res_code === '200') {
              for (let i = 0; i < res.data.list.length; i++) {
                res.data.list[i].no = this.listNo++
                res.data.list[i].type = "Payment"
                this.documents.push(res.data.list[i])
              }
            }else{
              if (res.res_code === '401012') {
                utils.setTokenRefresh().then(() => {
                  this.fnGetPayments()
                })
              } else {
                eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
              }
            }
          }
        })
      }
    },

    fnGetAnnualfees(){
      if (this.seq) {
        requestApi({
          url: '/applications/' + this.seq + '/upcoming/annualfees',
          method: 'GET',
          callback: (res) => {
            if (res.res_code === '200') {
              for (let i = 0; i < res.data.list.length; i++) {
                res.data.list[i].no = this.listNo++
                res.data.list[i].type = "Annual Fee"
                this.documents.push(res.data.list[i])
              }
            }else{
              if (res.res_code === '401012') {
                utils.setTokenRefresh().then(() => {
                  this.fnGetAnnualfees()
                })
              } else {
                eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
              }
            }
          }
        })
      }
    },
    fnSubmitConfirm(item) {
      requestApi({
        url: '/config/codes/'+ item.service_type_code,
        method: 'GET',
        callback: (res) => {
          if( res.res_code == '200'){
            let service_name = (this.$vuetify.rtl) ? res.data.name_ar : res.data.name_en
            let options = {
              text: this.$t('menu.new_service.confirm', {service_name: service_name}),
              yes: {
                text: this.$t('common.button.yes'),
                event: 'confirm',
                callback: {
                  item: item
                }
              },
              no: {
                text: this.$t('common.button.no')
              }
            }
            eventBus.$emit('SHOW_CONFIRM_DIALOG'+ this.id, options)
          }else{
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnSubmitConfirm(item)
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },

    fnSubmit(callback){
      let item = callback.item
      if(item.service_type_code === '6405'){
        //Submit missing document
        this.fnSubmitMissingDocument(item)
      }else if(item.service_type_code === '6406'){
        //Submit amendment
        this.fnSubmitAmendment(item)
      }else if(item.service_type_code === '6415'){
        //Final appeal
        this.fnRequestAppeal(item)
      } else if (item.service_type_code === '6407') {
        // Request voluntary amendment
        this.fnRequestVoluntaryAmendment(item)
      } else if (item.service_type_code === '6441' ||
          item.service_type_code === '6442' ||
          item.service_type_code === '6443' ||
          item.service_type_code === '6444' ||
          item.service_type_code === '6445') {
        this.fnSubmitDocument(item)
      }
    },

    fnSubmitDocument(item) {
      let params = {
        application_no: item.application_no,
        application_seq: Number(this.seq),
        service_type_code: item.service_type_code
      }

      requestApi({
        url: '/receivings/document',
        method: 'POST',
        data: params,
        callback: (res) => {
          if( res.res_code == '200'){
            this.$router.push('/modification/document/step1/'+ res.data.receipt_no)
          }else{
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnSubmitDocument(item)
              })
            } else {
              eventBus.$emit('CLOSE_CONFIRM_DIALOG'+ this.id)
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },

    fnRequestVoluntaryAmendment(item) {
      let params = {
        application_no : item.application_no,
        service_type_code: item.service_type_code
      }

      requestApi({
        url: '/receivings/amendment',
        method: 'POST',
        data: params,
        callback: (res) => {
          if( res.res_code == '200'){
            this.$router.push('/modification/voluntaryamendment/step2/'+res.data.receipt_no)
          }else{
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnRequestVoluntaryAmendment(item)
              })
            } else {
              eventBus.$emit('CLOSE_CONFIRM_DIALOG'+ this.id)
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },

    fnSubmitMissingDocument(item){
      let params = {
        application_seq : item.seq,
        service_type_code: item.service_type_code
      }

      //시퀀스로 신청 할 수 있게 변경
      //성공 시, response에 receipt_no가 들어있을것이다.
      //receipt_no를 이용해서 첨부문서 목록을 조회 할 수 있다.
      //신청 성공 시 My Request 에서 확인 가능
      requestApi({
        url: '/receivings/missing/document',
        method: 'POST',
        data: params,
        callback: (res) => {
          if( res.res_code == '200'){
            //신청 성공이라면 fnSubmitMissingDocument 화면 넘김
            this.$router.push('/myapplication/submitmissingdocument/step1/'+res.data.receipt_no)

          }else{
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnSubmitMissingDocument(item)
              })
            } else {
              eventBus.$emit('CLOSE_CONFIRM_DIALOG'+ this.id)
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },

    fnSubmitAmendment(item){
      let params = {
        application_no : item.application_no,
        service_type_code: item.service_type_code
      }

      requestApi({
        url: '/receivings/amendment',
        method: 'POST',
        data: params,
        callback: (res) => {
          if( res.res_code == '200'){
            //신청 성공이라면 SubmitAmendment로 화면 넘김
            this.$router.push('/myapplication/submitamendment/step1/'+res.data.receipt_no)

          }else{
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnSubmitAmendment(item)
              })
            } else {
              eventBus.$emit('CLOSE_CONFIRM_DIALOG'+ this.id)
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },

    fnRequestAppeal(item){
      let params = {
        application_no : item.application_no,
        service_type_code: item.service_type_code
      }

      requestApi({
        url: '/receivings/appeal',
        method: 'POST',
        data: params,
        callback: (res) => {
          if( res.res_code == '200'){
            //신청 성공이라면 Request Appeal로 화면 넘김
            this.$router.push('/appeal/step2/'+res.data.receipt_no)

          }else{
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnRequestAppeal(item)
              })
            } else {
              eventBus.$emit('CLOSE_CONFIRM_DIALOG'+ this.id)
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },

    getColor (status_type_code) {
      if (status_type_code === '8941') return '#99bc44'
      else if (status_type_code === '8942') return '#00af50'
      else if (status_type_code === '8943') return '#00af50'
      else return '#1f94a6'
    }
  }
}
</script>